'use strict';

export default {
  discountCodes: {
    labels: {
      discountCodes: 'Discount Codes',
      code: 'Code',
      quantity: 'Qty',
      expirationDate: 'Expiration Date',
      discount: 'Discount',
    },
    errors: {
      invalidExpirationDate: 'The expiration date is invalid',
      codeRequired: 'The code is required',
      quantityInvalid: 'The quantity must be a valid number greater than 0',
      discountMin: 'The discount must be higher or equal than 0',
      discountMax: 'The discount must be lower or equal than 100%',
      discountValueRequired: 'The discount value is required',
    },
  },
};
